<div class="">
  @if (isCanceledOffer) {
    <div class="d-flex align-items-center gap-4">
      <div class="fs-13 text-red">Offre de mission annulée</div>
    </div>
  } @else if (candidateScope) {
    <div class="d-flex align-items-center gap-4">
      <div [class]="'fs-13 ' + candidateStatus.css">{{ candidateStatus.label }}</div>
    </div>
  } @else {
  @if (totallyValidated) {
    <div class="d-flex align-items-center gap-4">
      <div class="fs-13" [class.text-accent-green]="_data.missionStatus === 'VALIDATED'" [class.required]="_data.missionStatus !== 'VALIDATED'">{{ totallyValidated }}</div>
    </div>
  } @else if (_data.missionStatus === MissionStatusEnum.DRAFT) {
    <div class="d-flex align-items-center gap-4">
      <div class="fs-13 text-accent">Brouillon</div>
    </div>
  } @else if (expired) {

    @if (totallyValidated) {
      <div class="d-flex align-items-center gap-4">
        <div class="fs-13" [class.text-accent-green]="_data.missionStatus === 'VALIDATED'" [class.required]="_data.missionStatus !== 'VALIDATED'">{{ totallyValidated }}</div>
      </div>
    } @else {
      <div class="d-flex align-items-center gap-4">
        <div [class]="'fs-13 ' + finishedStatus.css" [attr.title]="finishedStatus.tooltip || null">{{ finishedStatus.label }}</div>
      </div>
    }


  } @else if (!statusCandidateAccepted) {

    @switch (_data.missionStatus) {
      @case (MissionStatusEnum.PENDING) {
        <div class="d-flex align-items-center gap-4">
          @if (isTotallyAffected()) {
            <div class="fs-13 text-accent-action">Offre de mission totalement affectée</div>
          } @else if (isAccepted()) {
            <div class="fs-13 text-accent-action">Acceptée</div>
          } @else if (isContractWaitingToBevalidated()) {
            <div class="fs-13 text-accent-action">Contrat en attente de validation</div>
          } @else  {
            <div class="fs-13 text-accent-action">Publiée en attente</div>
          }

        </div>
      }
      @case (MissionStatusEnum.DRAFT) {
        <div class="d-flex align-items-center align-items-center gap-2">
          <div class="fs-13 text-accent">Brouillon</div>
          <div class="d-flex gap-1 justify-content-center">
          </div>
        </div>

      }
      @case (MissionStatusEnum.FRAGMENTED_NOT_ALL_ASIGNED) {
        <div class="d-flex align-items-center gap-4">
          <div class="fs-13 text-accent-action">
            Offre de mission partiellement affectée
          </div>
        </div>
      }
      @case (MissionStatusEnum.FRAGMENTED_ALL_ASIGNED) {
        <div class="d-flex align-items-center gap-4">
          <div class="fs-13 text-accent-action">Offre de mission totalement affectée</div>
        </div>
      }
      @case (MissionStatusEnum.CANCELED) {
        <div class="d-flex align-items-center gap-4">
          <div class="fs-13 text-red">Offre de mission annulée</div>
        </div>
      }
      @default {
        <div class="d-flex align-items-center gap-4">
          <div class="fs-13 text-accent-action">En cours</div>
        </div>
      }
    }


  } @else {
    <div class="">
      @switch (statusCandidateAccepted) {
        @case (CandidatStatusOnMission.ACCEPTED) {
          @if (expired && _data.missionStatus == CandidatStatusOnMission.INVALIDATED) {
            <div class="d-flex align-items-center gap-4 flex-wrap">
              <div class="fs-13 text-accent-yellow d-flex gap-2">
                <svg-icon src="assets/icons/warning.svg"></svg-icon>
                Validation refusée
              </div>
            </div>
          } @else if (expired && _data.missionStatus == CandidatStatusOnMission.VALIDATED) {
            <div class="fs-13 text-accent-green">Valider</div>

          } @else {
            <div class="d-flex align-items-center gap-1 flex-wrap">
              <div class="fs-13 text-accent-green">Acceptée</div>
            </div>
          }
        }
        @case (CandidatStatusOnMission.PAYMENT_DONE) {
          <div class="d-flex align-items-center gap-4">
            <div class="fs-13 text-accent-green">Payé</div>
          </div>
        }
        @case (CandidatStatusOnMission.ACCEPTED_AND_SIGNED_BY_BOTH) {
          <div class="d-flex align-items-center gap-1">
            <div class="fs-13 text-accent-green">Offre totalement affectée</div>
          </div>
        }
        @case (CandidatStatusOnMission.CANDIDAT_APPLIED_ON_THIS_MISSION) {
          <div class="d-flex align-items-center gap-1">
            <div class="fs-13 text-accent-green"
                 [tooltip]="'Le professionnel de santé a postulé pour cette mission. Nous sommes en attente de la confirmation de l’établissement'">
               Candidature en attente
            </div>
          </div>
        }
        @case (CandidatStatusOnMission.REJECTED) {
          <div class="d-flex align-items-center gap-1">
            <div class="fs-13 text-accent-green"
                 [tooltip]="'Le professionnel de santé a postulé pour cette mission. Nous sommes en attente de la confirmation de l’établissement'">
              Candidature refusée
            </div>
          </div>
        }
        @case (CandidatStatusOnMission.WAITING_FOR_ESTABLISHMENT_VALIDATION) {
          <div class="d-flex align-items-center gap-4">
            <div class="fs-13 required">En attente de validation</div>
          </div>
        }
        @case (CandidatStatusOnMission.MISSION_VALIDATED_WAITING_FOR_PAYMENT) {
          <div class="d-flex align-items-center gap-4">
            <div class="fs-13 text-accent-green">Validée en attente de paiement</div>
          </div>
        }
        @case (CandidatStatusOnMission.VALIDATION_REJECTED_BY_ESTABLISHMENT) {
          <div class="d-flex align-items-center gap-4">
            <div class="fs-13 required">Validation refusée</div>
          </div>
        }
        @default {
          <div class="fs-13 text-secondary">{{ totallyValidated || '—' }}</div>
        }
      }
    </div>

  }
  }

</div>
